import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer/ContentContainer';
import { InfoList, InfoListItem, InfoListItemSkeleton, } from '@/components/ui/List/InfoList';
import { Paginate } from '@/components/ui/Navigation/Paginate';
import { Card } from '@/components/ui/Surface/Card/Card';
import { Text } from '@/components/ui/Typography/Body/Text';
import { Head } from '@/components/ui/Typography/Heading/Head';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
import { useLoadingPagination } from '@/hooks/ui/Navigation/useLoadingPagination';
import { stringifyUrl } from '@/utils/libs/query-string/stringify';
import { myPagePath, releaseOnePath, releaseListPath, } from '@/utils/router/links';
const listClassName = 'mt-12';
export const ReleaseListView = (props) => {
    const { currentPage = 1, isGuestUser, loading = false, onChangePage: propOnPageChange, releaseList, totalPageCount = 1, } = props;
    const pans = useMemo(() => {
        const myPage = { link: myPagePath(), text: 'マイページ' };
        const news = { text: 'ニュース' };
        return isGuestUser ? [news] : [myPage, news];
    }, [isGuestUser]);
    /** ページネーションリンク設定 */
    const paginateLink = useCallback((page) => stringifyUrl({
        query: { page },
        url: releaseListPath(),
    }), []);
    // ページネーション ローディング表示制御
    const { onPageChange: onChangePage, prevItemCount } = useLoadingPagination({
        initialItemCount: 5,
        itemCount: releaseList === null || releaseList === void 0 ? void 0 : releaseList.length,
        onPageChange: propOnPageChange,
    });
    /** スケルトン表示用のダミー配列 */
    const dummies = useArrayWithIndex(prevItemCount);
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, { lists: pans }), _jsxs(ContentContainer, Object.assign({ className: 'mx-auto mb-80', maxWidthPoint: 'xl' }, { children: [_jsxs(Card, Object.assign({ className: clsx('pt-40 px-16 xs:px-20 lg:px-40 pb-24'), isShadow: true }, { children: [_jsx(Head, Object.assign({ className: 'text-center', color: 'base', size: 'md' }, { children: "\u30CB\u30E5\u30FC\u30B9" })), (() => {
                                // ローディング中
                                if (loading && !releaseList) {
                                    return (_jsx(InfoList, Object.assign({ className: listClassName }, { children: dummies.map(({ index }) => (_jsx(InfoListItemSkeleton, {}, `InfoListItemSkeleton_${index}`))) })));
                                }
                                // 0件表示
                                if (!(releaseList === null || releaseList === void 0 ? void 0 : releaseList.length)) {
                                    return (_jsx(Text, Object.assign({ className: clsx('py-16', 'text-center', listClassName), color: 'base', size: 'md' }, { children: "\u73FE\u5728\u516C\u958B\u4E2D\u306E\u304A\u77E5\u3089\u305B\u306F\u3042\u308A\u307E\u305B\u3093\u3002" })));
                                }
                                // 通常表示
                                return (_jsx(InfoList, Object.assign({ className: listClassName }, { children: releaseList.map((newsItem) => {
                                        // 遷移用のリンク先がない場合は表示しない
                                        if (newsItem.file === null && newsItem.detail_id === null) {
                                            return null;
                                        }
                                        return (_jsx(InfoListItem, { date: newsItem.display_from_at, isPdf: !!newsItem.file && newsItem.detail_id === null, linkTo: !!newsItem.file && newsItem.detail_id === null
                                                ? newsItem.file.url
                                                : releaseOnePath(`${newsItem.detail_id}`), tagText: newsItem.category.name, title: newsItem.title }, newsItem.id));
                                    }) })));
                            })()] })), !!(releaseList === null || releaseList === void 0 ? void 0 : releaseList.length) &&
                        typeof totalPageCount === 'number' &&
                        totalPageCount > 1 && (_jsx("div", Object.assign({ className: 'mt-40' }, { children: _jsx(Paginate, { className: 'items-center justify-center', forcePage: currentPage - 1, hrefBuilder: paginateLink, onPageChange: onChangePage, pageCount: totalPageCount, pageRangeDisplayed: 5 }) })))] }))] }));
};
